import { render, staticRenderFns } from "./service-config-field.component.vue?vue&type=template&id=e49102be"
import script from "./service-config-field.component.vue?vue&type=script&lang=ts"
export * from "./service-config-field.component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports